/**
 * Partner / certification badges with brand-color logo marks.
 * SVG marks are simplified, non-trademarked geometric renditions in each brand's color
 * to represent partnership without reproducing copyrighted logo artwork.
 */
const PARTNERS = [
  {
    name: 'Google Partner',
    color: '#4285F4',
    svg: (
      <svg viewBox='0 0 24 24' className='w-4 h-4'>
        <path fill='#4285F4' d='M22.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.4h5.9c-.3 1.4-1 2.5-2.2 3.3v2.7h3.5c2.1-1.9 3.3-4.8 3.3-8.1z' />
        <path fill='#34A853' d='M12 23c3 0 5.5-1 7.3-2.7l-3.5-2.7c-1 .7-2.3 1.1-3.8 1.1-2.9 0-5.4-2-6.3-4.6H2.1v2.8C3.9 20.5 7.7 23 12 23z' />
        <path fill='#FBBC05' d='M5.7 14.1c-.5-1.4-.5-2.9 0-4.3V7H2.1C.5 10.2.5 13.8 2.1 17l3.6-2.9z' />
        <path fill='#EA4335' d='M12 5.4c1.6 0 3.1.6 4.2 1.7l3.1-3.1C17.5 2.1 14.9 1 12 1 7.7 1 3.9 3.5 2.1 7l3.6 2.8C6.6 7.4 9.1 5.4 12 5.4z' />
      </svg>
    ),
  },
  {
    name: 'Meta Business',
    color: '#0866FF',
    svg: (
      <svg viewBox='0 0 24 24' className='w-4 h-4'>
        <path fill='#0866FF' d='M12 2C6.5 2 2 6.5 2 12c0 5 3.7 9.1 8.4 9.9v-7H8v-2.9h2.4V9.8c0-2.4 1.4-3.7 3.6-3.7 1 0 2.1.2 2.1.2v2.3h-1.2c-1.2 0-1.5.7-1.5 1.5v1.8h2.6l-.4 2.9h-2.2v7C18.3 21.1 22 17 22 12c0-5.5-4.5-10-10-10z' />
      </svg>
    ),
  },
  {
    name: 'GA4 Certified',
    color: '#F9AB00',
    svg: (
      <svg viewBox='0 0 24 24' className='w-4 h-4'>
        <rect x='3' y='11' width='4' height='10' rx='1' fill='#F9AB00' />
        <rect x='10' y='7' width='4' height='14' rx='1' fill='#F9AB00' opacity='0.85' />
        <rect x='17' y='3' width='4' height='18' rx='1' fill='#F9AB00' opacity='0.7' />
      </svg>
    ),
  },
  {
    name: 'HubSpot Solutions',
    color: '#FF7A59',
    svg: (
      <svg viewBox='0 0 24 24' className='w-4 h-4'>
        <circle cx='17' cy='7' r='2.5' fill='none' stroke='#FF7A59' strokeWidth='1.8' />
        <circle cx='7' cy='17' r='3.5' fill='none' stroke='#FF7A59' strokeWidth='1.8' />
        <path d='M9 15 L15 9' stroke='#FF7A59' strokeWidth='1.8' />
        <circle cx='7' cy='17' r='1.2' fill='#FF7A59' />
      </svg>
    ),
  },
  {
    name: 'Shopify Plus',
    color: '#95BF47',
    svg: (
      <svg viewBox='0 0 24 24' className='w-4 h-4'>
        <path fill='#95BF47' d='M15.4 4.6c-.1-.4-.4-.5-.7-.6-.2-.1-.9-.2-2 .1-.6-.5-1.5-.9-2.4-.7-1.7.4-3.1 2.2-3.6 3.8-.4.1-1.7.5-2 .6-.5.2-.5.2-.6.7-.1.3-1.4 10-1.4 10L12.7 21l7.1-1.5C19.8 19.5 15.5 5 15.4 4.6z' />
      </svg>
    ),
  },
  {
    name: 'Snowflake',
    color: '#29B5E8',
    svg: (
      <svg viewBox='0 0 24 24' className='w-4 h-4' stroke='#29B5E8' strokeWidth='1.8' fill='none' strokeLinecap='round'>
        <path d='M12 2v20M4.5 6.5l15 11M4.5 17.5l15-11M2 12h20' />
        <circle cx='12' cy='12' r='2' fill='#29B5E8' stroke='none' />
      </svg>
    ),
  },
  {
    name: 'LinkedIn Ads',
    color: '#0A66C2',
    svg: (
      <svg viewBox='0 0 24 24' className='w-4 h-4'>
        <path fill='#0A66C2' d='M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5V9h3v10zM6.5 7.5A1.75 1.75 0 118.25 5.75 1.75 1.75 0 016.5 7.5zM19 19h-3v-5c0-1.2-.5-2-1.7-2s-1.8.9-1.8 2v5h-3V9h3v1.3c.5-.8 1.5-1.5 2.9-1.5 2 0 3.6 1.3 3.6 4V19z' />
      </svg>
    ),
  },
  {
    name: 'TikTok Business',
    color: '#25F4EE',
    svg: (
      <svg viewBox='0 0 24 24' className='w-4 h-4'>
        <path fill='#FF004F' d='M15 3v10.5a2.5 2.5 0 11-2.5-2.5v-3a5.5 5.5 0 105.5 5.5V8a7.5 7.5 0 004 1.2V6.2a4.5 4.5 0 01-3-2 4.5 4.5 0 01-1-1.2z' />
        <path fill='#25F4EE' d='M14 2v10.5A2.5 2.5 0 1111.5 10v-3a5.5 5.5 0 105.5 5.5V7A7.5 7.5 0 0021 8.2V5.2A4.5 4.5 0 0117 3a4.5 4.5 0 01-1-1z' opacity='0.85' />
      </svg>
    ),
  },
];

export default function PartnerBadges() {
  return (
    <div className='flex flex-wrap justify-center items-center gap-3'>
      {PARTNERS.map((p) => (
        <div
          key={p.name}
          className='group inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-white/5 border border-white/10 hover:bg-white/8 hover:border-white/25 transition-all'
        >
          <div className='w-5 h-5 shrink-0 rounded-md bg-white flex items-center justify-center'>
            {p.svg}
          </div>
          <span className='text-white/80 text-[12px] tracking-wider uppercase font-accent font-semibold group-hover:text-white transition-colors'>
            {p.name}
          </span>
        </div>
      ))}
    </div>
  );
}
